<template>
  <div>
    <div ref="myPage" style="height:calc(100vh - 50px);width:100%;">
      <SeeksRelationGraph
        ref="seeksRelationGraph"
        :options="graphOptions"
        :on-node-click="onNodeClick"
        :on-line-click="onLineClick">
        <div slot="node" slot-scope="{node}" class="c-node-box">
         <div style="border:#000000 dashed 1px;position: relative;">
          <div style="width:64px;height:64px;cursor: pointer;border-radius: 50%;position: relative;" @click="showNodeMenus(node, $event)" @contextmenu.prevent.stop="showNodeMenus(node, $event)">       
            <img width='64' height='64' :src="node.data.myImg">
            <div v-if="node.id==2">&nbsp;</div>
            <div v-else class="circle-box"  >
              <div class="circle-dev" style=" width: 64px; height: 64px;">
                <img v-if="node.data.isImgShow"  width='30' height='30' src="../../../assets/images/suo.png">
                <div v-if="node.data.isLocked"  class="circle-bg"  style=" width: 64px; height: 64px;"></div>
                <div v-if="node.data.isDelayLocked" class="round" style=" width: 64px; height: 64px;">
                  <span class="ouro ouro3"  style=" width: 64px; height: 64px;">
                    <span class="left"><span class="anim"></span></span>
                    <span class="right"><span class="anim"></span></span>
                  </span>
                </div>
            </div>
            </div>          
          </div>
          </div>
          <div class="circle-name" style="width: 160px;height:25px;line-height: 25px;margin-top:5px;margin-left:-48px;font-size: 16px;">
            {{ node.data.text }}
          </div>
        </div>
      </SeeksRelationGraph>
    </div>

  </div>
</template>

<script>
import SeeksRelationGraph from 'relation-graph'
import { setTimeout } from 'timers'
import cardController from '@/controller/card'
export default {
  components: { SeeksRelationGraph },
  data() {
    return {
      nodes:[ ],
       links: [],
      nodeMaskId:999999,
      isShowCodePanel: false,
 
      
      graphOptions: {
        allowSwitchLineShape: true,
        allowSwitchJunctionPoint: true,
        defaultNodeColor: 'rgba(250, 250, 250, 0)',
        layouts: [
          {
            'label': '中心',
            'layoutName': 'center',
            'layoutClassName': 'seeks-layout-center'
          }
        ],
        defaultJunctionPoint: 'border',
        // 这里可以参考"Graph 图谱"中的参数进行设置
        allowShowMiniNameFilter: false,
        allowShowMiniToolBar: false,
        // disableZoom: true,
        "defaultNodeBorderWidth": 0,
        "defaultNodeWidth": "64",
        "defaultNodeHeight": "64",
        "defaultLineColor": "#000000",
        "defaultLineShape": 1
      },
       
    }
  },
  mounted() {
    this.showSeeksGraph()
  },
 computed: {
    mobile() {
      return this.$route.params.mobile
    },
 },
  methods: {
    nodeMaskClick(id){
      let self=this;
      this.nodes.forEach((item,index)=>{
        if(item.id===id){
          if(item.data.isLocked){
            self.nodes[index].data.isLocked=false;
            self.nodes[index].data.isDelayLocked=true
          }
          setTimeout(function(){
              self.nodes[index].data.isDelayLocked=false;
              self.nodes[index].data.isImgShow=false;
              console.log(self.nodes[index].data.isDelayLocked)
              console.log(self.nodes[index].data.isImgShow)
          },1600)
        }        
      })
    },
   async showSeeksGraph() {
    let cardMap=await cardController.getIOSCardHome(this.$route.query.mobile);
    let nodesData =cardMap.cardVOS;
    let linksData = cardMap.relationVOS;
    for(var i=0;i<nodesData.length;i++){
        let node={
        id:0,
        name:undefined,
        data:{
            myImg:undefined,
            text:undefined,
            isLocked:true,
             }
        }
       
          node.id=nodesData[i].id;
          node.name=nodesData[i].name;
          node.data.myImg=nodesData[i].imageUrl;
          node.data.text=nodesData[i].name;
          if(nodesData[i].lockStatus==3){
            console.info(nodesData[i])
            node.data.isLocked=false;
          }else{
            node.data.isLocked=true;
          }
          if(nodesData[i].core==2){
            this.rootId=nodesData[i].id;
          }
          this.nodes.push(node);
        }
         console.info(this.nodes);
    for( i=0;i<linksData.length;i++){
      let link={
        from:undefined,
        to:undefined,
        text:undefined,
        fontColor:'rgba(14, 14, 14, 1)',
        isHideArrow:true
      }
      link.from=linksData[i].parentCardId.toString();
      link.to=linksData[i].childCaredId.toString();
      link.text=linksData[i].relation;
      this.links.push(link);
    }
   
      var __graph_json_data = {
        rootId: '2',
        nodes: this.nodes,
        links: this.links
      }
      this.$refs.seeksRelationGraph.setJsonData(__graph_json_data, (seeksRGGraph) => {
        // 这些写上当图谱初始化完成后需要执行的代码
        console.log(__graph_json_data)
         console.log(seeksRGGraph)
      })
    },
    onNodeClick(nodeObject, $event) {
      console.log('onNodeClick:', nodeObject)
      console.log($event)
      
    },
    onLineClick(lineObject, $event) {
      console.log('onLineClick:', lineObject)
      console.log($event)
    },
    showNodeMenus(nodeObject, $event) {
      this.currentNode = nodeObject
      var _base_position = this.$refs.myPage.getBoundingClientRect()
      console.log('showNodeMenus:', $event, _base_position)
    },
  }
}
</script>

<style>
.rel-node-shape-0 {
   padding: 0px  !important;
   
}
.rel-node-checked {
   box-shadow: 0px 0px 0px #FD8B37 !important;
}
.circle-name{
  color: #000000;
  position: absolute;
  z-index:999;
  text-align: center;
}
.c-node-menu-item{
 cursor: pointer;color: #444444;font-size: 14px;border-top:#efefef solid 1px;
}
.c-node-menu-item:hover{
  background-color: rgba(66,187,66,0.2);
}
.circle-box{
  position: absolute;
  left: 0;
  top: 0;
}

.circle-dev{
  position: relative;
}
.circle-bg{
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  background: none repeat scroll 0 0 #000000;
  opacity: 0.6;
}
.circle-dev img{position: absolute; top:28px;left: 28px; z-index: 3;}
.ouro {
    position: relative;
    display:inline-block;
    border-radius: 50%;  
    overflow:hidden;
    box-shadow: 0 0 10px rgba(0,0,0,.1) inset, 0 0 25px rgba(0,0,255,0.075);
}

.ouro:after {
    content: "";
    position: absolute;
    top: 9px; left: 9px;
    display: block;
    height: 28px; width: 28px;
    background: none repeat scroll 0 0 #F2F2F2;
    border-radius: 50%;
    box-shadow: 0 0 10px rgba(0,0,0,.1);
}
.ouro > span {
    position: absolute;
    height: 100%; width: 50%;
    overflow: hidden;
}
.left  { left:0;background: none repeat scroll 0 0 #000000;
    opacity: 0.6;}
.right { left:50%; background: none repeat scroll 0 0 #000000;
    opacity: 0.6;}

.anim {
    position: absolute;
    left: 100%; top: 0;
    height: 100%; width: 100%;
    border-radius: 999px;
    background: none repeat scroll 0 0 #ffffff;
    -webkit-animation: ui-spinner-rotate-left 1s 1s linear infinite;
    animation: ui-spinner-rotate-left 1s 1s linear infinite;
    -webkit-transform-origin: 0 50% 0;
    transform-origin: 0 50% 0;
}
.left .anim {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
}
.right .anim {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    left: -100%;
    -webkit-transform-origin: 100% 50% 0;
    transform-origin: 100% 50% 0;
}

/* v3 */
.ouro3 .anim {
   -webkit-animation-delay: 0s;
   -webkit-animation-duration:3s;
   -webkit-animation-timing-function: linear;
   -webkit-animation-iteration-count: 1;
   animation-iteration-count:1;
   animation-delay: 0s;
   animation-duration:3s;
   animation-timing-function: linear;  
}

.ouro3 .right .anim{
   -webkit-animation-name: ui-spinner-rotate-right;
   -webkit-animation-delay:0;
   -webkit-animation-iteration-count: 1;
   animation-iteration-count:1;
   animation-name: ui-spinner-rotate-right;
   animation-delay:0;
}

/* round variation */

.round .ouro:after {display:none }
.round {
  position: relative;
  z-index: 2;
}

@keyframes ui-spinner-rotate-right{
  0%{transform:rotate(0deg)}
  25%{transform:rotate(180deg)}
  50%{transform:rotate(180deg)}
  75%{transform:rotate(360deg)}
  100%{transform:rotate(360deg)}
}
@keyframes ui-spinner-rotate-left{
  0%{transform:rotate(0deg)}
  25%{transform:rotate(0deg)}
  50%{transform:rotate(180deg)}
  75%{transform:rotate(180deg)}
  100%{transform:rotate(360deg)}
}

@-webkit-keyframes ui-spinner-rotate-right{
  0%{-webkit-transform:rotate(0deg)}
  25%{-webkit-transform:rotate(180deg)}
  50%{-webkit-transform:rotate(180deg)}
  75%{-webkit-transform:rotate(360deg)}
  100%{-webkit-transform:rotate(360deg)}
}
@-webkit-keyframes ui-spinner-rotate-left{
  0%{-webkit-transform:rotate(0deg)}
  25%{-webkit-transform:rotate(0deg)}
  50%{-webkit-transform:rotate(180deg)}
  75%{-webkit-transform:rotate(180deg)}
  100%{-webkit-transform:rotate(360deg)}
}
</style>
